// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1fvb0","col":"styles_col__2S7aw","fulfillmentStatus":"styles_fulfillmentStatus__nr-1H","emailCol":"styles_emailCol__2oKzs"};